
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/fonts.css'
import 'flag-icons/css/flag-icons.min.css'
import './i18n'
// PrimeReact styles
import 'primereact/resources/themes/lara-dark-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

// Font loading detection
const fontLoader = () => {
  if ('fonts' in document) {
    // Modern browsers
    Promise.all([
      document.fonts.load('300 16px Montserrat'),
      document.fonts.load('400 16px Montserrat'),
      document.fonts.load('500 16px Montserrat'),
      document.fonts.load('600 16px Montserrat'),
      document.fonts.load('700 16px Montserrat'),
      document.fonts.load('bold 16px Uniqueen-Bold'),
    ]).then(() => {
      document.documentElement.classList.add('fonts-loaded');
      document.documentElement.classList.remove('font-loading');
    }).catch(() => {
      // Fallback if fonts fail to load
      document.documentElement.classList.add('fonts-loaded');
      document.documentElement.classList.remove('font-loading');
    });
  } else {
    // Fallback for older browsers
    setTimeout(() => {
      document.documentElement.classList.add('fonts-loaded');
      document.documentElement.classList.remove('font-loading');
    }, 1000);
  }
};

// Initialize font loading
fontLoader();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
